import React from 'react';
import './BlogHubCards.css';
import '../styles/common.css';

export default function BlogHubCards() {
  const phases = [
    {
      phase: 'Phase 1',
      num: '01',
      cta: 'Velog #1',
      title: 'Learning to Build',
      desc: '기초를 쌓고 실패하면서 개발 사고를 만든 시기',
      href: 'https://velog.io/@calico/posts',
    },
    {
      phase: 'Phase 2',
      num: '02',
      cta: 'Velog #2',
      title: 'Building with Context',
      desc: '실무 문제를 다루며 관점과 기준이 생긴 시기',
      href: 'https://velog.io/@corone_hi/posts',
    },
    {
      phase: 'Phase 3',
      num: '03',
      cta: 'Tistory',
      title: 'Ongoing Practice',
      desc: '현재 관심사와 실제 개발 과정을 기록하는 진행형 로그',
      href: 'https://calicorone.tistory.com/',
    },
  ];

  return (
    <section className="bloghub" aria-label="Blog Hub">
      <div className="bloghub-list">
        {phases.map((p) => (
          <a
            key={p.phase}
            className="bloghub-row"
            href={p.href}
            target="_blank"
            rel="noreferrer"
            data-stagger
          >
            <span className="bloghub-num">{p.num}</span>
            <div className="bloghub-body">
              <span className="bloghub-phase">{p.phase}</span>
              <span className="bloghub-title">{p.title}</span>
              <span className="bloghub-desc">{p.desc}</span>
            </div>
            <span className="bloghub-cta">{p.cta} →</span>
          </a>
        ))}
      </div>
    </section>
  );
}
